import apiClient from "@/services/api-client";
import { useQuery } from "@tanstack/react-query";
import { errorLogger } from "@/utils/helpers/logger";
//import { cleanUrl } from "@/utils/filterUtils";

const fetchCategoryData = (url) => {
  return apiClient({
    method: "get",
    url: `/v1${url}`,
  });
};

export const useFetchCategoryData = (routerPath, useQueryOptions) => {
  let url = routerPath.replace("category", "categories");

  let urlWithoutAny = url;

  return useQuery({
    queryKey: ["category", url],
    queryFn: () => fetchCategoryData(urlWithoutAny),
    ...useQueryOptions,
    keepPreviousData: true,
    select: (data) => {
      let apiData = data.data?.data;
      return apiData;
    },
    onError: (error) => {
      errorLogger.logApiError(error);
    },
  });
};

export const useGetComboDealsData = (useQueryOptions) => {
  const { category } = useQueryOptions;
  const url = `/categories/${category}`;

  return useQuery({
    queryKey: ["category", url],
    queryFn: () => fetchCategoryData(url),
    ...useQueryOptions,
    keepPreviousData: true,
    select: (data) => {
      let products = data.data?.data?.products.map(
        ({ name, slug, main_picture, default_variation }) => ({
          name,
          slug,
          main_picture,
          offer_percent: default_variation.offer_percent,
          offer_price: default_variation.offer_price,
          price: default_variation.price,
          variation: default_variation.variation,
        })
      );

      return products;
    },
    onError: (error) => {
      errorLogger.logApiError(error);
    },
  });
};
